import React, {Component} from 'react'
import {style, media, merge} from 'glamor'
import * as colors from '../../colors'
import Thumb from '../ThumbCategory'
import Panel from '../Panel'
import SectionTitle from '../SectionTitle'
import Label from '../Label'
import find from 'lodash.find'
import getMedia from '../../utils/getMedia'

export default class Project extends Component {

  //
  // shouldComponentUpdate(){
  //   return false
  // }


  componentDidMount(){
    window.scrollTo(0, 0)
  }


  render(){
    const gallery = find(this.props.pages, {url: `/${this.props.params.type}`})
    const category = find(gallery.items, {id: this.props.params.category})
    const project = find(category.items, {id: this.props.params.id})
    return (
      <div
        {...merge(
          style({
            padding: '1.5rem',
            // paddingTop: '6rem',

            width: '100%',
            // height: '100vh',
            zIndex: 9,
            color: colors.white
            // display: 'flex',
            // alignItems: 'center'
          }),
          media('(min-width: 800px)', {
            padding: '2rem'
          }),
          media('(min-width: 1000px)', {
            padding: '4rem'
          })
      )}
      >

        <div
          ref='content'
          {...style({
            position: 'relative',
            zIndex: 1,
            overflow: 'hidden'
          })}
        >
            <div


            {...merge(
              style({
                marginBottom: '2rem',
                fontSize:'2rem',
                padding: 0
              }),
              media('(min-width: 800px)', {
                fontSize:'3rem',
                width: '80%',
              }),
              media('(min-width: 1000px)', {
                fontSize:'4rem',
                width: '66.6666%',
                marginTop: '0rem',
                marginBottom: '4rem',
              })
            )}

            >
              {project.title}
            </div>

            <div
              {...merge(
                style({
                  width: '100%'
                }),
                media('(min-width: 1000px)', {
                  width: '50%',
                })
              )}
            >

            <SectionTitle>
              Contexte
            </SectionTitle>

            <div
              {...style({
                marginBottom: '2rem',
              })}
            >
              {project.context}
            </div>

            <SectionTitle>
              L'idée
            </SectionTitle>
            <div
              {...merge(
                style({
                  marginBottom: '3rem',
                }),
                media('(min-width: 800px)', {

                  marginBottom: '4rem',
                })
              )}
            >
              {project.idea}
            </div>
            </div>

          <div
            {...merge(
              style({
                marginBottom: '3rem',
              }),
              media('(min-width: 800px)', {

                marginBottom: '4rem',
              })
            )}
          >
            {
              project.images.map((media, i)=>{
                const Comp = getMedia(media.src)
                return (
                  <div
                    key={i}
                    {...style({
                      marginBottom: '2rem'
                    })}
                  >
                    <Comp src={media.src}/>
                  </div>
                )
              })
            }
          </div>

          {
            project.meta.map(({name, value}, i)=>(
              <div
                key={i}
                {...merge(
                  style({
                    marginBottom: '1.5rem',
                  }),
                  media('(min-width: 800px)', {
                    // marginBottom: '4rem',
                  })
                )}
              >
                <SectionTitle>
                  {name}
                </SectionTitle>
                <div>
                  {value}
                </div>
              </div>
            ))

          }

        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/pages/Project.js
 **/